export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8827.a668b4bc.jpg";